import React from "react";
import { capitalizeCamelCase } from "../utils/commonFunctions";

export default function InputLayout({
  label,
  name,
  required,
  col,
  extraClassName = "",
  errorMessage,
  data,
  children,
  ignoreLabel,
}) {
  col = parseInt(col);
  if (col > 12) {
    col = 12;
  }

  return (
    <div className={`input-layout col-12  xl:col-${col} ${extraClassName}`}>
      <label htmlFor={name} className="text-sm font-semibold">
        <div className="mb-1">
          {!ignoreLabel ? (label ? label : capitalizeCamelCase(name)) : null}
          {!ignoreLabel && required ? (
            <span className="text-red-500">*</span>
          ) : null}
        </div>
      </label>
      {children}
      {errorMessage || data?.formErrors?.[name] ? (
        <small className="p-error font-light text-sm">
          {errorMessage || data?.formErrors?.[name]}
        </small>
      ) : null}
    </div>
  );
}
